import { useContext, useEffect, useState } from "react";
import { useNavigate, useParams } from "../../router";
import {
  Breadcrumb,
  Button,
  Spin,
  Typography,
  message,
} from "antd";
import {
  ArrowLeftOutlined,
} from "@ant-design/icons";

import { Context } from "../../context";
import ReelForm from "../../components/ManageReels";

import "./styles.css";

const { Title, Text } = Typography;

const EditReel = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const { getSingleReel, updateReel, formatReelsApiError } = useContext(Context);

  const [loading, setLoading] = useState(false);
  const [pageLoading, setPageLoading] = useState(true);
  const [initialValues, setInitialValues] =
    useState(null);

  useEffect(() => {
    fetchReel();
  }, [id]);

  const fetchReel = async () => {
    try {
      setPageLoading(true);

      const reel = await getSingleReel(id);

      setInitialValues({
        title: reel.title || "",
        hindiTitle: reel.hindiTitle || "",
        seriesId: reel.seriesId || "",
        playbackUrl: reel.playbackUrl || "",
        iosPlaybackUrl:
          reel.iosPlaybackUrl || "",
        thumbnailImage:
          reel.thumbnailImage || "",
        priority: reel.priority,
        status: reel.status,
      });
    } catch (error) {
      console.error(error);

      message.error(
        formatReelsApiError(error?.data) ||
          error?.message ||
          "Failed to load reel"
      );

      navigate("/reels");
    } finally {
      setPageLoading(false);
    }
  };

  const handleSubmit = async (values) => {
    try {
      setLoading(true);

      if (!values.seriesId) {
        message.error("Please select a webseries");
        return;
      }

      const payload = {
        title: values.title?.trim(),
        hindiTitle: values.hindiTitle?.trim() || null,
        seriesId: String(values.seriesId),
        playbackUrl: values.playbackUrl?.trim() || null,
        iosPlaybackUrl: values.iosPlaybackUrl?.trim() || null,
        thumbnailImage: values.thumbnailImage?.trim() || null,
        priority: values.priority ?? null,
        status: Boolean(values.status),
      };

      await updateReel(id, payload);

      message.success(
        "Reel updated successfully"
      );

      navigate("/reels");
    } catch (error) {
      console.error(error);

      message.error(
        formatReelsApiError(error?.data) ||
          error?.message ||
          "Failed to update reel"
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="reels-page">
      <Breadcrumb style={{ marginBottom: 16 }}>
        <Breadcrumb.Item>
          Reels
        </Breadcrumb.Item>

        <Breadcrumb.Item>
          Edit Reel
        </Breadcrumb.Item>
      </Breadcrumb>

      <div className="reels-page-header">
        <div>
          <Title level={4}>
            Edit Reel
          </Title>

          <Text type="secondary">
            Update reel details
          </Text>
        </div>

        <Button
          icon={<ArrowLeftOutlined />}
          onClick={() =>
            navigate("/reels")
          }
        >
          Back
        </Button>
      </div>

      <Spin spinning={pageLoading}>
        {initialValues && (
          <ReelForm
            initialValues={initialValues}
            loading={loading}
            submitLabel="Update Reel"
            onSubmit={handleSubmit}
          />
        )}
      </Spin>
    </div>
  );
};

export default EditReel;
